module.exports = __webpack_public_path__ + "img/fantom-logo.06b18da1.svg";